import Vue from "vue";
import config from "@/config/config.app.json";

export default {

  /**
   * Get one device
   *
   * @param deviceId
   * @param successCallback
   * @param errorCallback
   */
  requestDevice(deviceId, successCallback, errorCallback) {
    Vue.prototype.$rhRequest.sendGet({
      endpoint: 'devices/get-device',
      params: { id: '' + deviceId}
    }, successCallback, errorCallback)
  },

  /**
   * Get all devices for the active gateway. Filters are exclusive.
   *
   * @param successCallback
   * @param errorCallback
   * @param deviceIdFilter array of device ids to include
   * @param deviceTypeIdsFilter array of device type ids to include
   */
  requestListData(successCallback, errorCallback, deviceIdFilter = null, deviceTypeIdsFilter = null) {
    let params = {}
    if (deviceTypeIdsFilter) {
      params["deviceTypes"] = deviceTypeIdsFilter
    } else if (deviceIdFilter) {
      params["deviceIds"] = deviceIdFilter
    }

    Vue.prototype.$rhRequest.sendGet({
      endpoint: "devices/list",
      params: params
    }, successCallback, errorCallback)
  },

  requestListDataByDeviceTypes(deviceTypeIdsFilter, successCallback, errorCallback) {
    this.requestListData(successCallback, errorCallback, null, deviceTypeIdsFilter)
  },

  requestListDataByDeviceIds(deviceIdFilter, successCallback, errorCallback) {
    this.requestListData(successCallback, errorCallback, deviceIdFilter)
  },

  /**
   * returns a Promise with additional device data for the passed device ids
   *
   * @param deviceIds
   * @return {Promise<unknown>}
   */
  requestListPreviewData(deviceIds) {
    return new Promise((resolve, reject) => {
      if (deviceIds.length === 0) {
        resolve([])
      } else {
        Vue.prototype.$rhRequest.sendGet({
          endpoint: "devices/list-preview",
          params: { deviceIds: deviceIds }
        }, (resp) => {
          resolve(resp?.data?.data);
        }, (err) => {
          console.error(err);
          reject(err);
        });
      }
    });
  },

  /**
   * Requests additional device data in parallel with page size; returns a list
   * of Promises
   *
   * @param devices
   * @return {*[]}
   */
  requestListPreviewDataWithPaging(devices) {
    let promises = []
    let pageSize = config.deviceListPageSize ?? 25
    for (let i = 0; i < devices.length; i += pageSize) {
      promises.push(this.requestListPreviewData(devices.map(item => item.id).slice(i, i + pageSize)))
    }
    return promises;
  },

  /**
   * Merges additionalDataItems into the device list passed as param 'devices'
   *
   * Data structure of both objects must be like this:
   * {deviceId1: {...data}, deviceId2: {...data}, ...}
   *
   * @param devices
   * @param additionalDataItems
   * @return {*}
   */
  mergeDeviceData(devices, additionalDataItems) {
    return devices.map(device => {
      let matchingFields = additionalDataItems[device.id];
      if (matchingFields) {
        // add data via the spread operator
        return {
          ...device,
          ...matchingFields
        };
      }
      // return the unaltered device if there is no match in items
      return device;
    });
  }
};
